// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import 'myWorld/base/view';

/**
 * Provides a common api for UI Components
 * @class BaseComponent
 * @param  {boolean} options.visible Display the component on render
 * @param  {string} options.cssClass Additional css classes to add to the component
 */
myw.BaseComponent = myw.View.extend({
    blackListParams: ['onChange', 'onClick'], // A list of keys we dont want to be passed to jquery

    options: {
        visible: true,
        cssClass: ''
    },

    render(options) {
        if (!this.options.visible) {
            return this;
        }

        if (this.options.cssClass) {
            this.$el.addClass(this.options.cssClass);
        }

        if (options && options.parent) {
            this.parent = options.parent;
            this.parent.append(this.$el);
        }
        return this;
    },

    /**
     * Add a attribute to an element
     * @param  {string} key  Attribute key
     * @param  {string} value  Attribute value
     */
    addAttribute(key, value) {
        if (value != null && typeof value != 'undefined') {
            this.$el.attr(key, value);
        }
    }
});

export default myw.BaseComponent;
